import React, { useState } from "react";
import { IconButton, MenuItem, Stack, Typography } from "@mui/material";
import { LuInfo } from "react-icons/lu";
import FormBooking from "../../form-booking";

interface ISeat {
  data?: any;
}

function Seat({ data }: ISeat) {
  const [openForm, setOpenForm] = useState<boolean>(false);

  return (
    <>
      {openForm && (
        <FormBooking open={openForm} onClose={() => setOpenForm(false)} />
      )}
      <Stack
        component={MenuItem}
        sx={{
          width: "100%",
          border: "1px solid",
          borderColor: "divider",
          paddingTop: "100%",
          position: "relative",
        }}
      >
        <Stack
          justifyContent="space-between"
          sx={{
            position: "absolute",
            zIndex: 10,
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            p: 1,
          }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
            A{data?.name}
          </Typography>
          <Stack direction="row" alignItems="center" justifyContent="flex-end">
            <IconButton onClick={() => setOpenForm(true)}>
              <LuInfo size={20} />
            </IconButton>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
}

export default Seat;
